/* eslint-disable max-len */
export const alertsMessages = {
    'Alert.affected_app': 'Affected Application',
    'Alert.confirm_delete': 'Are you sure you want to delete this alert?',
    'Alert.create_success': 'Successfully created alert.',
    'Alert.delivery_method': 'Delivery Method',
    'Alert.error_no_destinations': 'You must enter at least 1 destination.',
    'Alert.event': 'Alert Event',
    'Alert.last_triggered': 'Last Triggered',
    'Alert.object_involved': 'Object Involved',
    'Alert.removed': 'Alert Removed',
    'Alert.set_as_default': 'Set as Default',
    'Alert.tab_create': 'Create Alert',
    'Alert.triggered': 'Alert Triggered',
    'Alerts.alertCreation': 'Alert Creation',
    'Alerts.alertingHistory': 'Alerting History',
    'Alerts.creation': 'Alert Creation',
    'Alerts.delete_success': 'Successfully deleted alert.',
    'Alerts.history': 'Alerting History',
    'Alerts.page_retirement_notice':
        'Do not worry—everything you need (plus more advanced insights!) is available on the new <DashboardLink />. We are making it easier to access and act on your data in one place.',
    'Alerts.page_retirement_notice_title':
        'Heads up! This page is being retired soon.'
};
